import { Component, Output, EventEmitter, OnInit, AfterViewInit, OnDestroy, Injector, Input, SimpleChanges, OnChanges, ViewChild } from '@angular/core';
import { RSSWAResource } from '../rsswa';
import { RsswaService } from '../rsswa.service';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TokenInfoService } from 'src/app/services/authentication/token-info.service';
import { WfSignatureResource, WFTaskSignatureResource } from '../../workflow/workflow';
import { WorkFlowService } from 'src/app/components/workflow/workflow.service';
import { BaseComponent } from 'src/app/common/base/base.component';
import { FormViewState } from 'src/app/common/models/form-view-state';
import { RsswaSection1Component } from './rsswa-section1/rsswa-section1.component';

@Component({
  selector: 'rsswa-main-panel',
  templateUrl: './rsswa-main-panel.component.html',
  styleUrls: ['./rsswa-main-panel.component.scss']
})
/* rsswa-main-panel component*/
/**
 * Main panel component for the RSSWA feature.
 *
 * This component manages the display and interaction logic for RSSWA resources,
 * including amendments, document handling, and workflow signatures. It provides
 * several input properties to control its state and outputs various events to
 * notify parent components of user actions or state changes.
 *
 * @extends BaseComponent
 * @implements OnInit
 *
 * @input rsswa - The current RSSWA resource to display or edit.
 * @input showAmendment - Flag indicating whether to show amendment-related UI.
 * @input testingCompleteSigned - Indicates if testing is complete and signed.
 *
 * @output loading - Emits loading state changes.
 * @output requestRefresh - Requests a refresh with a specific identifier.
 * @output unselectTable - Emits when a table is unselected.
 * @output displayDocument - Emits the identifier of a document to display.
 * @output newDocument - Emits when a new document is created.
 * @output toggleSidePanel - Emits when the side panel should be toggled.
 * @output changed - Emits when the RSSWA resource changes.
 *
 * @property isSa - Indicates if the current user is a system administrator.
 * @property showEditButton - Controls the visibility of the edit button.
 * @property windowScrolled - Tracks if the window has been scrolled.
 * @property tmpSerialNo - Temporary serial number for internal use.
 * @property serialNo - The current serial number.
 * @property tmpStatus - Temporary status string.
 * @property amendment - Indicates if the current context is an amendment.
 * @property viewAmendment - Controls viewing of amendments.
 * @property editAmendment - Controls editing of amendments.
 * @property startNewClicked - Tracks if the "start new" action was clicked.
 * @property currentDocument - The currently selected document.
 * @property maxHeight - The maximum height for the content area.
 * @property contentWidth - The width of the content area.
 * @property prevScrollpos - The previous scroll position.
 * @property tmpWfTableId - Temporary workflow table ID.
 * @property amendmentSignature - Signature resource for amendments.
 * @property wfTaskSignature - Signature resource for workflow tasks.
 * @property IsCopyTaskVisible - Controls visibility of the copy task feature.
 * @property subEditing - Subscription for editing state.
 *
 * @constructor
 * @param rsswaService - Service for RSSWA resource operations.
 * @param rolePrivilegeService - Service for user role and privilege information.
 * @param router - Angular Router for navigation.
 * @param wfs - Workflow service for workflow operations.
 * @param injector - Angular Injector for dependency injection.
 *
 * @method ngOnInit - Initializes the component and sets up responsive behavior.
 * @method responsiveFunction - Adjusts layout based on window size.
 * @method changedEvent - Handles changes to the RSSWA resource.
 * @method setLoading - Emits loading state changes.
 */
export class RsswaMainPanelComponent extends BaseComponent implements OnInit, OnChanges {
  @Input() rsswa?: RSSWAResource | null;
  @Input() testingCompleteSigned? = false;
  @Input() status!: FormViewState;

  @ViewChild(RsswaSection1Component) section1!: RsswaSection1Component;

  //@Output() loading = new EventEmitter<boolean>();
  @Output() requestRefresh = new EventEmitter<number>();
  @Output() unselectTable = new EventEmitter<any>();
  @Output() displayDocument = new EventEmitter<string>();
  @Output() newDocument = new EventEmitter<any>();
  @Output() toggleSidePanel = new EventEmitter<any>();

  @Output() changed = new EventEmitter<RSSWAResource | null>();

  isSa = false;
  showEditButton: boolean = false;
  windowScrolled: boolean = false;
  tmpSerialNo!: string;
  serialNo!: string;
  tmpStatus = '';
  amendment = false;
  viewAmendment = false;
  editAmendment = false;
  startNewClicked = false;
  currentDocument: any = null;
  maxHeight: string | null = null;
  contentWidth: any;
  prevScrollpos = window.pageYOffset;

  tmpWfTableId: number | null = null;
  amendmentSignature: WfSignatureResource = new WfSignatureResource();
  wfTaskSignature: WFTaskSignatureResource = new WFTaskSignatureResource();

  IsCopyTaskVisible = false;
  // Clock timer real-time
  subEditing!: Subscription;

  constructor(
    public rsswaService: RsswaService,
    public rolePrivilegeService: TokenInfoService,
    public router: Router,
    private wfs: WorkFlowService,
    protected override injector: Injector
  ) {
    super(injector);
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  ngOnInit() {
    this.responsiveFunction();
  }

  /**
   * Retains the editor's unsaved amendment fields while the current form view is displayed.
   */
  preservePendingAmendmentChanges(): void {
    // Keep the section snapshot inside the component that owns its temporary form values.
    this.section1.preservePendingAmendmentChanges();
  }


  responsiveFunction() {
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
    this.maxHeight = (this.innerHeight - 320) + 'px';
  }

  changedEvent(e: RSSWAResource | null) {
    this.rsswa = e;
    this.changed.emit(this.rsswa);
  }

  setLoading(val: boolean) {
    //this.loading.emit(val);
  }

}
